import {
  GET_BASIC_SELLER_INFORMATION,
  GET_BASIC_SELLER_INFORMATION_ERROR,
  GET_BASIC_SELLER_INFORMATION_SUCCESS,
  GET_ECONOMIC_ACTIVITIES_INFO,
  GET_ECONOMIC_ACTIVITIES_INFO_ERROR,
  GET_ECONOMIC_ACTIVITIES_INFO_SUCCESS,
  GET_SELLER_BLOCKED_INFO,
  GET_SELLER_BLOCKED_INFO_ERROR,
  GET_SELLER_BLOCKED_INFO_SUCCESS,
  GET_SELLER_LEGAL_ADDRESS,
  GET_SELLER_LEGAL_ADDRESS_ERROR,
  GET_SELLER_LEGAL_ADDRESS_SUCCESS,
  GET_USER_PERSONAL_INFO,
  GET_USER_PERSONAL_INFO_ERROR,
  GET_USER_PERSONAL_INFO_SUCCESS
} from './BasicSellerInformationSection.actions'

const basicSellerInformationState = {
  EMTClassificationDetail: {
    description: '',
    id: ''
  },
  abilityStatus: '',
  accreditationEndDate: '',
  blockedInfo: {
    error: null,
    isBlocked: false,
    loading: false,
    reason: ''
  },
  contractStatus: 0,
  dni: '',
  error: undefined,
  isMinorSizeSeller: true,
  loading: true,
  orgAddress: {
    error: undefined,
    loading: true,
    value: ''
  },
  orgLegalName: '',
  orgName: '',
  sellerIsEliminated: false,
  sellerIsSuspended: false,
  sellerType: '',
  suspensionReason: '',
  userEconomicActivities: {
    error: undefined,
    loading: false
  },
  userInfo: {
    error: undefined,
    loading: false
  }
}

/**
 * The Basic Seller Information reducer.
 */
const basicSellerInformationReducer = (state = basicSellerInformationState, { payload, type }) => {
  switch (type) {
    case GET_BASIC_SELLER_INFORMATION: {
      return {
        ...state,
        loading: true
      }
    }
    case GET_BASIC_SELLER_INFORMATION_ERROR: {
      return {
        ...state,
        dni: payload.dni,
        error: payload.error,
        loading: false
      }
    }
    case GET_BASIC_SELLER_INFORMATION_SUCCESS: {
      return {
        ...state,
        EMTClassificationDetail: payload.EMTClassificationDetail,
        abilityStatus: payload.abilityStatus,
        accreditationEndDate: payload.accreditationEndDate,
        contractStatus: payload.contractStatus,
        dni: payload.dni,
        error: false,
        isMinorSizeSeller: payload.isMinorSizeSeller,
        loading: false,
        orgLegalName: payload.orgLegalName,
        orgName: payload.orgName,
        sellerIsEliminated: payload.sellerIsEliminated,
        sellerIsSuspended: payload.sellerIsSuspended,
        sellerType: payload.sellerType,
        suspensionReason: payload.suspensionReason
      }
    }
    case GET_ECONOMIC_ACTIVITIES_INFO: {
      return {
        ...state,
        userEconomicActivities: {
          error: undefined,
          loading: true
        }
      }
    }
    case GET_ECONOMIC_ACTIVITIES_INFO_ERROR: {
      return {
        ...state,
        userEconomicActivities: {
          error: payload.error,
          loading: false
        }
      }
    }
    case GET_ECONOMIC_ACTIVITIES_INFO_SUCCESS: {
      return {
        ...state,
        userEconomicActivities: {
          activities: payload,
          error: undefined,
          loading: false
        }
      }
    }
    case GET_SELLER_BLOCKED_INFO: {
      return {
        ...state,
        blockedInfo: {
          ...state.blockedInfo,
          error: null,
          loading: true
        }
      }
    }
    case GET_SELLER_BLOCKED_INFO_ERROR: {
      return {
        ...state,
        blockedInfo: {
          ...state.blockedInfo,
          error: payload.error,
          loading: false
        }
      }
    }
    case GET_SELLER_BLOCKED_INFO_SUCCESS: {
      return {
        ...state,
        blockedInfo: {
          ...state.blockedInfo,
          isBlocked: payload.isBlocked,
          loading: false,
          reason: payload.reason
        }
      }
    }
    case GET_SELLER_LEGAL_ADDRESS: {
      return {
        ...state,
        orgAddres: {
          loading: true
        }
      }
    }
    case GET_SELLER_LEGAL_ADDRESS_ERROR: {
      return {
        ...state,
        orgAddress: {
          loading: false,
          error: payload.error
        }
      }
    }
    case GET_SELLER_LEGAL_ADDRESS_SUCCESS: {
      return {
        ...state,
        orgAddress: {
          loading: false,
          value: payload.orgAddress
        }
      }
    }
    case GET_USER_PERSONAL_INFO: {
      return {
        ...state,
        userInfo: {
          error: undefined,
          loading: true
        }
      }
    }
    case GET_USER_PERSONAL_INFO_ERROR: {
      return {
        ...state,
        userInfo: {
          error: payload.error,
          loading: false
        }
      }
    }
    case GET_USER_PERSONAL_INFO_SUCCESS: {
      return {
        ...state,
        userInfo: {
          ...payload,
          error: undefined,
          loading: false
        }
      }
    }
    default: {
      return state
    }
  }
}

export default basicSellerInformationReducer
